import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/r'
)({
  loader: () => ({
    crumb: 'Recordings',
  }),
})
